module.exports = __webpack_public_path__ + "static/media/3.353e47e7.jpeg";